import { createContext } from "react";

const ThreeDContext = createContext();

export default ThreeDContext;
